import { Outlet } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
var Minimal = function () { return /*#__PURE__*/ _jsx("div", { children: /*#__PURE__*/ _jsx("main", { slot: "app-main", children: /*#__PURE__*/ _jsx(Outlet, {}) }) }); };
export default Minimal;
